import { Injectable } from '@angular/core';
import { CountryConfigurationService } from '../country/country-configuration';

@Injectable({ providedIn: 'root' })
export class PhoneMaskStrategy {
  constructor(private readonly countryConfig: CountryConfigurationService) {}

  getMask(countryCode: string | null): string {
    return this.countryConfig.getPhoneMask(countryCode);
  }

  getPrefix(countryCode: string | null): string {
    return this.countryConfig.getPhonePrefix(countryCode);
  }

  getPlaceholder(countryCode: string | null): string {
    return this.countryConfig.getPhonePlaceholder(countryCode);
  }
}
